<template>
  <div
    class="community_search_header" @click="clickHandle"
    v-if="isKeep"
  >
    <img
      class="search-icon"
      src="../../assets/images/community/search-icon.png"
      alt=""
    />
      <mySwiper
        v-if="bannerList.length > 0 && isKeep"
        ref="search_banner_swiper"
        :loop="bannerList.length > 1 ? true : false"
        :slidesNum="1"
        :autoplay="bannerList.length > 1 ? true : false"
        :autoplayNumber="3000"
        :allowTouchMove="false"
        direction="vertical"
        :paginationFlag="false"
        :centeredSlides="true"
        swipeid="search_banner_swiper"
        @slideChange="slideChange"
      >
        <div
          class="swiper-slide"
          slot="swiper-con"
          v-for="(banner, index) in bannerList"
          :data="
            JSON.stringify({
              xmhh5_home_banner_url: banner.link,
              banner_station: index + 1,
            })
          "
          :key="banner.id"
        >
          <p class="notice-item">{{banner.content}}</p>
        </div>
      </mySwiper>

    <p class="notice-item" v-else>搜索</p>
    <span class="search_btn">搜索</span>
  </div>
</template>

<script>
import mySwiper from "@/components/common/mySwiper/mySwiper.vue"; //轮播图
import { TestUserAgent, Debounce } from "@/assets/js/common.js";
import openWxTag from "@/components/common/openWeappTag/index.vue";
import { xmhh5CommunityClick_fn } from "@/assets/js/BuriedPointEvent";
export default {
  name: "searchHeader",
  data() {
    return {
      bannerList: [], //banner列表
      UserInfo: {},
      unionid: "",
      isSystem: "",
      activeIndex: 0,
      isKeep: false,
    };
  },
  components: { mySwiper, openWxTag },
  mounted() {
    this.getBannerList();
    this.isSystem = TestUserAgent().isios;
  },
  activated(){
    this.isKeep = true
  },
  deactivated(){
    this.isKeep = false
  },
  methods: {
    slideChange(index) {
      this.activeIndex = index == this.bannerList.length + 1 ? 0 : index - 1;
    },
    clickHandle:Debounce(function() {
      xmhh5CommunityClick_fn("xmhh5CommunityClick", {
        xmhh5_Community_Search_Click: "首页-搜索",
        xmhh5_Community_Find_Click: this.bannerList.length > 0 && this.bannerList[this.activeIndex].content || ""
      })
      this.$router.push({
        path: "/grassSearch",
        query: {
          hot: this.bannerList.length > 0 && this.bannerList[this.activeIndex].content || ""
        }
      })
    }),
    // 获取banner列表
    getBannerList() {
      this.$http.post(
        "/content/search/query",
        {},
        {columnId:12 },
        (res) => {
          if (res.code === 200) {
            this.isKeep = true;
            this.bannerList = res.data || [];
          }
        },
        (err) => {
          console.log(err);
        },
        "lucky"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.community_search_header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  padding: 0 3px 0 11px;
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #f3a0d7;
  border-radius: 16px;

  .search-icon {
    width: 14px;
    height: 14px;
    margin-right: 2px;
  }
  /deep/.mySwiper {
    width: auto;
    flex: 1;
   .swiper-container {
    height: 30px;
    overflow: hidden !important;
    padding-bottom: 0 !important;
    .swiper-wrapper {
      .swiper-slide {
        height: 30px;
        border-radius: 6px 6px 0px 0px;
        display: flex;
        align-items: center;
        .notice-item {
          font-size: 12px;
          // line-height: 30px;
          color: #999999;
        }
      }
    }
    //
    .swiper-pagination-clickable {
      text-align: center;
      width: 100%;
      .swiper-pagination-bullet {
        width: 5px;
        height: 5px;
        background: #ffffff;
        border-radius: 50%;
        opacity: 0.5;
        margin: 0 3px;
        &.swiper-pagination-bullet-active {
          border-radius: 3px;
          width: 10px;
          opacity: 1;
        }
      }
    }
  }
  }

  .notice-item {
    flex: 1;
    font-size: 12px;
    color: #999999;
  }
  .search_btn {
    margin-left: 2px;
    padding: 0 9px;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
    color: #ffffff;
    background: linear-gradient(90deg, #FF76AE 0%, #CA56FF 100%);
    border-radius: 16px;
  }
}
</style>
